export default function baseUrl() {
  if (process.env.REACT_APP_DEPLOY_ENV === "production") {
    return process.env.REACT_APP_POCAPAN_PRODUCTION_HOST;
  } else if (process.env.REACT_APP_DEPLOY_ENV === "development") {
    return process.env.REACT_APP_POCAPAN_DEVELOPMENT_HOST
  } else {
    return process.env.REACT_APP_POCAPAN_LOCAL_HOST
  }
}
